import React from 'react';
import './ProgressBar.css';

const ProgressBar = ({ max, value, texto }) => {
  const percentage = max > 0 ? (value / max) * 100 : 0;

  return (
    <div>
      <p style={{
        fontSize: '0.9em',
        width: '100%',
        display: 'flex',
        alignItems: 'center',   
        justifyContent: 'start', 
        margin: '0 0 6px 0'
      }}>
        {texto}
        &nbsp;
        <span style={{ fontSize: '0.7em' }}>
          ( {value} de {max} )
        </span>
      </p>
      <div className="progress-bar-container" align="left">
        <div
          className="progress-bar"
          style={{ width: `${percentage}%` }}
        ></div>
        <span className="progress-label" align="left">{`${percentage.toFixed(2)}%`}</span>
      </div>
    </div>
  );
};

export default ProgressBar;
